function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Gray100Shadow } from "../fundations/effects/focusRing";
import { getBorderToken, getButtonToken, getIconToken, getTextToken } from "../fundations/palette/colorTokens";
import { Corner8 } from "../fundations/shape/corners";
export const ButtonGroup = {
    MuiButtonGroup: {
        defaultProps: {
            disableElevation: true,
            variant: "contained",
            disableRipple: true
        },
        variants: [
            {
                props: {
                    size: "large"
                },
                style: ({ theme })=>({
                        padding: theme.spacing(1.5, 3),
                        ".MuiIconButton-root": {
                            padding: theme.spacing(3),
                            "& .MuiSvgIcon-root": _object_spread_props(_object_spread({}, theme.typography.textMd), {
                                width: "24px",
                                height: "24px"
                            })
                        }
                    })
            },
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>({
                        padding: theme.spacing(1.25, 2.5),
                        ".MuiIconButton-root": {
                            padding: theme.spacing(3),
                            width: "20px",
                            height: "20px",
                            "& .MuiSvgIcon-root": _object_spread({}, theme.typography.textSm)
                        }
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1.25, 2.5)
                    }, theme.typography.textSm), {
                        ".MuiIconButton-root": {
                            padding: theme.spacing(2.5),
                            width: "20px",
                            height: "20px",
                            "& .MuiSvgIcon-root": _object_spread({}, theme.typography.textSm)
                        }
                    })
            },
            {
                props: {
                    size: "xsmall"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1, 2)
                    }, theme.typography.textSm), {
                        ".MuiIconButton-root": {
                            padding: theme.spacing(2),
                            width: "20px",
                            height: "20px",
                            "& .MuiSvgIcon-root": _object_spread({}, theme.typography.textSm)
                        }
                    })
            },
            {
                props: {
                    size: "2xsmall"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(0.75, 1.75)
                    }, theme.typography.textSm), {
                        ".MuiIconButton-root": {
                            padding: theme.spacing(1.75),
                            width: "20px",
                            height: "20px",
                            "& .MuiSvgIcon-root": _object_spread({}, theme.typography.textSm)
                        }
                    })
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: ()=>({
                        ".MuiIconButton-root": {
                            "&:last-child": {
                                borderRadius: `0 0 ${Corner8} ${Corner8}`,
                                borderTop: "none"
                            },
                            "&:first-child": {
                                borderRadius: `${Corner8} ${Corner8} 0 0`,
                                borderBottom: "none"
                            }
                        }
                    })
            },
            {
                props: {
                    orientation: "horizontal"
                },
                style: ()=>({
                        ".MuiIconButton-root": {
                            "&:last-child": {
                                borderLeft: "none",
                                borderRadius: `0 ${Corner8} ${Corner8} 0 `
                            },
                            "&:first-child": {
                                borderRight: "none",
                                borderRadius: `${Corner8} 0 0 ${Corner8}`
                            }
                        }
                    })
            }
        ],
        styleOverrides: {
            root: ({ theme })=>({
                    "& .MuiIconButton-root": {
                        color: getIconToken("iconSecondary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonSecondaryHover", theme)
                        },
                        "&:active": {
                            boxShadow: Gray100Shadow
                        },
                        "&:focus": {
                            boxShadow: Gray100Shadow
                        },
                        "&:disabled": {
                            background: "transparent",
                            borderColor: getBorderToken("borderDisabled", theme)
                        },
                        border: `1px solid ${getButtonToken("buttonSecondaryBorder", theme)}`,
                        borderRadius: 0
                    },
                    ".MuiButtonGroup-grouped": {
                        background: getButtonToken("buttonSecondary", theme),
                        color: getTextToken("secondary", theme),
                        "&:hover": {
                            background: getButtonToken("buttonSecondaryHover", theme)
                        },
                        "&:active": {
                            boxShadow: Gray100Shadow
                        },
                        "&:focus": {
                            boxShadow: Gray100Shadow
                        },
                        "&:disabled": {
                            background: "transparent",
                            borderColor: getBorderToken("borderDisabled", theme)
                        },
                        border: `1px solid ${getButtonToken("buttonSecondaryBorder", theme)}`,
                        "&:not(:last-child)": {
                            borderRight: "none"
                        }
                    },
                    ".MuiButtonGroup-groupedVertical": {
                        border: `1px solid ${getButtonToken("buttonSecondaryBorder", theme)} !important`,
                        "&:not(:last-child)": {
                            borderBottom: "none !important"
                        }
                    }
                })
        }
    }
};

//# sourceMappingURL=ButtonGroup.js.map